import { create } from 'zustand'
import type { FilterGroup } from '@/tableControls'

const SESSION_TTL_MS = 10 * 60 * 1000 // 10 minutes

interface EmailRulesFiltersState {
  filterTree: FilterGroup | null
  textSearch: string
  lastActivityAt: number | null

  setFilterTree: (tree: FilterGroup | null) => void
  setTextSearch: (query: string) => void
  clearFilters: () => void
  isSessionValid: () => boolean
  /** If the session is past TTL, reset filters. Call on mount and periodically. */
  expireSessionIfStale: () => boolean
}

function touchActivity(set: (partial: Partial<EmailRulesFiltersState>) => void) {
  set({ lastActivityAt: Date.now() })
}

export const useEmailRulesFiltersStore = create<EmailRulesFiltersState>((set, get) => ({
  filterTree: null,
  textSearch: '',
  lastActivityAt: null,

  setFilterTree: (filterTree) => {
    touchActivity(set)
    set({ filterTree })
  },

  setTextSearch: (textSearch) => {
    touchActivity(set)
    set({ textSearch })
  },

  clearFilters: () => {
    touchActivity(set)
    set({ filterTree: null, textSearch: '' })
  },

  isSessionValid: () => {
    const { lastActivityAt } = get()
    if (lastActivityAt == null) return false
    return Date.now() - lastActivityAt < SESSION_TTL_MS
  },

  expireSessionIfStale: () => {
    const { lastActivityAt } = get()
    if (lastActivityAt == null) return false
    if (Date.now() - lastActivityAt < SESSION_TTL_MS) return false
    set({ filterTree: null, textSearch: '', lastActivityAt: null })
    return true
  },
}))
